import React, { useState, useEffect } from "react"
import { Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Card } from "reactstrap"

// Import Components
import WelcomeComp from "./WelcomeComp"
import { CardBody } from "reactstrap"
import ActivityComp from "./ActivityComp"
import GeneralTaskReport from "./GeneralTaskReport"

//i18n
import { withTranslation } from "react-i18next"

import "../../assets/css/dashboard.css"
import PriorityTasks from "./PriorityTasks"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import { app_url } from "app_config"
import { Link } from "react-router-dom"

const Dashboard = props => {
  const [reports, setReports] = useState([
    { show: true },
    { show: true },
    { show: true },
    { show: true },
    { show: true },
    { show: true },
  ])

  const [allTasks, setAllTasks] = useState([])
  const [loading, setLoading] = useState(false)

  const [taskReport, setTaskReport] = useState([])
  const [notifications, setNotifications] = useState([])

  const { checkAccess, permissions } = usePermissionData()

  // getting dashboard datas
  useEffect(() => {
    if (permissions.length) {
      ; (async () => {
        try {
          setLoading(true)

          const { data } = await axiosbaseurl.get(`/dashboard-stats`)
          // const response1 = await axiosbaseurl.get(`/xero/invoices`)

          setReports([
            {
              title: "Total Employees",
              iconClass: "fa-users",
              description: data.data.totalEmployees,
              show: checkAccess(4, "view"),
              link: `${app_url}employees`,
            },
            {
              title: "Total Clients",
              iconClass: "fa-users",
              description: data.data.totalClients,
              show: checkAccess(1, "view"),
              link: `${app_url}clients`,
            },
            {
              title: "Total Tasks",
              iconClass: "fa-list",
              description: data.data.totalTasks,
              show: checkAccess(2, "view"),
              link: `${app_url}tasks`,
            },
            {
              title: "Pending Tasks",
              iconClass: "fa-list",
              description: data.data.totalPendingTasks,
              show: checkAccess(2, "view"),
              link: `${app_url}tasks`,
              data: "1",
            },
            { show: true },
            { show: true },
            // {
            //   title: "Total Invoices",
            //   iconClass: "fa-book",
            //   description: response1?.data?.totalInvoiceCount || "0",
            //   show: checkAccess(23, "view"),
            //   link: `${app_url}invoices`
            // },
            // {
            //   title: "Awaiting Payment Invoices",
            //   iconClass: "fa-book",
            //   description: response1?.data?.awaitingPaymentCount || "0",
            //   show: checkAccess(23, "view"),
            //   link: `${app_url}invoices`
            // },
          ])

          getInvoicesCounts()

          const statuses = data.data?.taskReport
            ?.filter(i => i.count)
            ?.sort((a, b) => a.sortOrder - b.sortOrder)
            ?.map(item => ({
              title: item.status,
              value: item.count,
              color: item.color,
            }))

          setTaskReport(statuses || [])

          const response = await axiosbaseurl.get("/tasks")

          if (response.data.success) {
            setAllTasks(
              response.data.data
                .map(item => ({
                  ...item,
                  clientName: item?.client?.clientName,
                  clientCode: item?.client?.clientCode,
                  statusName: item?.status?.statusName,
                }))
                ?.filter(t => t.client)
            )
          }

          const bellresponse = await axiosbaseurl.get("/bell-notification")

          if (bellresponse.data.success) {
            setNotifications(
              bellresponse.data.data
                ?.filter(item => item.module.toLowerCase().includes("task"))
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .slice(0, 3)
            )
          }
        } catch (error) {
          console.log(error)
        } finally {
          setLoading(false)
        }
      })()
    }
  }, [permissions])

  function getInvoicesCounts() {
    axiosbaseurl
      .get(`/xero/invoices`)
      .then(response => { 
        setReports(prev => {
          const temp = [...prev]
          temp.splice(
            4,
            2,
            {
              title: "Total Invoices",
              iconClass: "fa-book",
              description: response?.data?.totalInvoiceCount || "0",
              show: checkAccess(23, "view"),
              link: `${app_url}invoices`,
            },
            {
              title: "Awaiting Payment Invoices",
              iconClass: "fa-book",
              description: response?.data?.awaitingPaymentCount || "0",
              show: checkAccess(23, "view"),
              link: `${app_url}invoices?search=Awaiting Payment`,
            }
          )
          return temp
        })
      })
      .catch(error => {
        // setReports(prev => {
        //   const temp = [...prev]
        //   temp.splice(4, 2)
        //   return temp
        // })
        console.log(error)
      })
  }

  //meta title
  document.title = "Dashboard | Peacock Accountants Limited"

  const high_priority_tasks = allTasks
    ?.filter(item => item.taskPriorityStatus === "High")
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

  const auto_tasks = allTasks?.filter(item => item.isAutoCreated)

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content mb-5 ">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />
          <Row className="align-items-center">
            <Col xl="3">
              <WelcomeComp />
            </Col>
            <Col xl="9">
              <Row className="mb-2">
                {/* Reports Render */}
                {reports
                  .filter(r => r.show)
                  .map((report, key) => (
                    <Col md="4" key={"_col_" + key}>
                      <Card
                        className={`mini-stats-wid mb-3 ${!report.title && "skeleton-loading"
                          } `}
                      >
                        <CardBody>
                          <Link
                            to={report.link}
                            state={{ data: report.data || 0 }}
                            className="d-flex"
                          >
                            <div className={`flex-grow-1`}>
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i
                                  className={
                                    "fa " + report.iconClass + " font-size-18"
                                  }
                                ></i>
                              </span>
                            </div>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>

          {checkAccess(2, "view") && (
            <>
              <Row>
                <Col lg="12">
                  <PriorityTasks
                    heading={"High Priority Tasks"}
                    tasks_data={high_priority_tasks}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <PriorityTasks
                    heading={"Auto Generated Tasks"}
                    tasks_data={auto_tasks}
                  />
                </Col>
              </Row>

              <Row>
                {notifications.length ? (
                  <Col xl="4">
                    <ActivityComp notifications={notifications} />
                  </Col>
                ) : null}

                <Col xl={notifications.length ? 8 : 12}>
                  <GeneralTaskReport taskReport={taskReport} />
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Dashboard)
